import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { TaskIntakeRelativeDueDateType, ProposalStatus, TaskViewType, TodoLabel, BadgeState } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { orderBy, sortBy } from 'lodash-es';
import { AccessType } from '@poplar/types/enums';
import { uploadFiles } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { formatPartialDate } from '@yoweb/utils/date';
import { getOrdinalNumber } from '@yoweb/utils/getOrdinalNumber';
import { TASK_HAS_REPEATING_QUESTION_TAG_LABEL } from '@poplar/constants/tasks';
export var getDueDateOptions = function getDueDateOptions(t) {
  var dueDateOptions = [];

  for (var dueDateType in TaskIntakeRelativeDueDateType) {
    dueDateOptions.push({
      label: t("task-intake-due-date-options.".concat(TaskIntakeRelativeDueDateType[dueDateType]), {
        ns: 'common'
      }),
      value: TaskIntakeRelativeDueDateType[dueDateType].toString()
    });
  }

  return dueDateOptions;
};
export var isExpired = function isExpired(expirationTimestamp) {
  return Boolean(expirationTimestamp) && new Date() > new Date(expirationTimestamp);
};
var PERMITTED_SHAREABLE_STATUSES = [ProposalStatus.PROPOSAL_STATUS_COMPLETED, ProposalStatus.PROPOSAL_STATUS_PUBLISHED, ProposalStatus.PROPOSAL_STATUS_CONFIRMED];
var EXTENDED_PERMITTED_SHAREABLE_STATUSES = [ProposalStatus.PROPOSAL_STATUS_REJECTED, ProposalStatus.PROPOSAL_STATUS_CANCELLED];
export var isShareableProposal = function isShareableProposal(status, hasExtendedStatusSupport) {
  if (PERMITTED_SHAREABLE_STATUSES.includes(status)) {
    return true;
  }

  if (hasExtendedStatusSupport) {
    return EXTENDED_PERMITTED_SHAREABLE_STATUSES.includes(status);
  }

  return false;
}; // Gets date after N business days

export var addBusinessDaysToDate = function addBusinessDaysToDate(startDate, businessDaysToAdd) {
  var weekday = startDate.getDay(); // Add 1 to account for today

  var daysToAdd = businessDaysToAdd + 1; // Special rule for Saturday

  if (weekday === 6) {
    daysToAdd += 1;
  } else if (6 - weekday <= daysToAdd) {
    daysToAdd += 2; // add the weekend;
  }

  startDate.setDate(startDate.getDate() + daysToAdd);
  return startDate;
};
export var FOURTEEN_DAYS_IN_MS = 60 * 60 * 24 * 14 * 1000; // If member has the baton on a completed task the user hasn't given feedback yet.
// A user cannot provide feedback on tasks that was completed more than 14 days ago.

export var getTaskNeedsFeedback = function getTaskNeedsFeedback(task, accessType) {
  return Boolean([AccessType.LIMITED, AccessType.FULL].includes(accessType) && task.taskView === TaskViewType.TASK_VIEW_TYPE_COMPLETED && task.todoStatusMessage === TodoLabel.TODO_LABEL_MEMBER_HAS_THE_BATON && task.updated && task.updated > new Date().getTime() - FOURTEEN_DAYS_IN_MS);
};
export var sortCommentList = function sortCommentList(commentList) {
  // Get list of comments and sort them in accending order by createdAt date
  var sortedCommentsList = sortBy(commentList, 'createdAt').reverse();
  return orderBy(sortedCommentsList, [// Sort comments in ascending order by numUnreadMessages
  function (discussion) {
    return discussion.numUnreadMessages === 0;
  }, // Sort in decending order latest created message
  function (discussion) {
    var _discussion$messages;

    var lastMessageGroup = (_discussion$messages = discussion.messages) === null || _discussion$messages === void 0 ? void 0 : _discussion$messages[(discussion === null || discussion === void 0 ? void 0 : discussion.messages.length) - 1];
    return (lastMessageGroup === null || lastMessageGroup === void 0 ? void 0 : lastMessageGroup[0]) && (lastMessageGroup === null || lastMessageGroup === void 0 ? void 0 : lastMessageGroup[lastMessageGroup.length - 1].createdAt);
  }], ['asc', 'desc']);
};
export var sortProposals = function sortProposals(proposalSnippets) {
  return (// get list of proposalSnippets and sort them by status asc then by updated timestamp desc
    orderBy(proposalSnippets, ['status', 'statusUpdateTimestamp'], ['asc', 'desc'])
  );
};

/**
 * Upload any new documents to the server.
 * New documents are to have a local File reference.
 * Ignore already uploaded documents, but return all documents together if the upload succeeds.
 */
export var uploadNewDocuments = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, withSafeFetch) {
    var documents, uploadedFiles, didUploadSucceed, filesToUpload, attachedFiles, uploadResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            documents = _ref.documents;
            uploadedFiles = [];
            didUploadSucceed = true;
            filesToUpload = documents.filter(function (document) {
              return document.file;
            });

            if (!filesToUpload.length) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return withSafeFetch(uploadFiles(filesToUpload));

          case 7:
            uploadResponse = _context.sent;

            if (uploadResponse.status === ApiResponseStatus.OK && uploadResponse.data) {
              uploadedFiles = uploadResponse.data.map(function (_ref3) {
                var uuid = _ref3.uuid;
                return {
                  fileUuid: uuid
                };
              });
            } else {
              didUploadSucceed = false;
            }

          case 9:
            if (didUploadSucceed) {
              // combine newly uploaded files and previously uploaded files into one list
              attachedFiles = [].concat(_toConsumableArray(uploadedFiles), _toConsumableArray(documents.filter(function (document) {
                return !document.file;
              })));
            }

            return _context.abrupt("return", attachedFiles);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadNewDocuments(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var validatePathOfBranchingQuestions = function validatePathOfBranchingQuestions(task) {
  var validatedPath = [];
  task.pathOfBranchingQuestionsList.forEach(function (order) {
    if (task.questionsList[order - 1]) {
      validatedPath.push(order);
    }
  });
  return validatedPath;
};
export var getActionItem = function getActionItem(badge, t) {
  var type = badge === null || badge === void 0 ? void 0 : badge.type;
  var count = badge === null || badge === void 0 ? void 0 : badge.totalCount;

  switch (type) {
    case BadgeState.BADGE_STATE_PROPOSAL_READY:
      return t('options-ready');

    case BadgeState.BADGE_STATE_MULTIPLE_ITEMS_TO_REVIEW:
      return t('quick-tasks', {
        count: count
      });

    case BadgeState.BADGE_STATE_NEW_CHANNEL_MESSAGES:
    case BadgeState.BADGE_STATE_CHANNEL_UNREAD_COMMENTS:
      return t('new-comment', {
        count: count
      });

    case BadgeState.BADGE_STATE_READY_FOR_GENERAL_FEEDBACK:
      return t('share-feedback');

    case BadgeState.BADGE_STATE_UNSPECIFIED:
    default:
      return null;
  }
};
export var getRepeatInfoString = function getRepeatInfoString(t, locale, repeatSetting) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'standard';
  var repeatInfoString = doGetRepeatInfoString(t, locale, repeatSetting, type);
  return repeatInfoString ? "".concat(repeatInfoString.charAt(0).toUpperCase()).concat(repeatInfoString.slice(1)) : undefined;
};

var doGetRepeatInfoString = function doGetRepeatInfoString(t, locale, repeatSetting) {
  var _repeatSetting$weekly, _repeatSetting$biweek, _repeatSetting$annual, _repeatSetting$annual2;

  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'standard';

  if (!repeatSetting) {
    return;
  }

  if ((_repeatSetting$weekly = repeatSetting.weekly) !== null && _repeatSetting$weekly !== void 0 && _repeatSetting$weekly.dayOfWeek) {
    return t("recurring.weekly.".concat(type), {
      weekday: t("recurring.weekdays.".concat(repeatSetting.weekly.dayOfWeek))
    });
  }

  if ((_repeatSetting$biweek = repeatSetting.biweekly) !== null && _repeatSetting$biweek !== void 0 && _repeatSetting$biweek.dayOfWeek) {
    return t("recurring.biweekly.".concat(type), {
      weekday: t("recurring.weekdays.".concat(repeatSetting.biweekly.dayOfWeek))
    });
  }

  if (repeatSetting.monthly) {
    var _repeatSetting$monthl, _repeatSetting$monthl2;

    if (repeatSetting.monthly.day) {
      return t("recurring.monthly.day.".concat(type), {
        day: getOrdinalNumber(repeatSetting.monthly.day, locale)
      });
    } else if ((_repeatSetting$monthl = repeatSetting.monthly.weekAndDayOfMonth) !== null && _repeatSetting$monthl !== void 0 && _repeatSetting$monthl.dayOfWeek && (_repeatSetting$monthl2 = repeatSetting.monthly.weekAndDayOfMonth) !== null && _repeatSetting$monthl2 !== void 0 && _repeatSetting$monthl2.occurenceNum) {
      return t("recurring.monthly.occurrance.".concat(type), {
        weekday: t("recurring.weekdays.".concat(repeatSetting.monthly.weekAndDayOfMonth.dayOfWeek)),
        occurrence: t("recurring.occurrence.".concat(repeatSetting.monthly.weekAndDayOfMonth.occurenceNum))
      });
    }
  }

  if ((_repeatSetting$annual = repeatSetting.annually) !== null && _repeatSetting$annual !== void 0 && _repeatSetting$annual.day && (_repeatSetting$annual2 = repeatSetting.annually) !== null && _repeatSetting$annual2 !== void 0 && _repeatSetting$annual2.month) {
    return t("recurring.yearly.".concat(type), {
      date: formatPartialDate({
        day: repeatSetting.annually.day,
        month: repeatSetting.annually.month
      }, {
        locale: locale,
        preset: 'defaults'
      })
    });
  }
};

export var isTaskRecurring = function isTaskRecurring(questionsList) {
  var _iterator = _createForOfIteratorHelper(questionsList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var question = _step.value;

      if (question.tagsList.some(function (tag) {
        return tag.label === TASK_HAS_REPEATING_QUESTION_TAG_LABEL;
      }) && question.answerOptionsList.some(function (option) {
        var _option$singleChoiceA, _option$singleChoiceA2, _option$singleChoiceA3;

        return ((_option$singleChoiceA = option.singleChoiceAnswer) === null || _option$singleChoiceA === void 0 ? void 0 : (_option$singleChoiceA2 = _option$singleChoiceA.answeredValue) === null || _option$singleChoiceA2 === void 0 ? void 0 : (_option$singleChoiceA3 = _option$singleChoiceA2.localizedTextValue) === null || _option$singleChoiceA3 === void 0 ? void 0 : _option$singleChoiceA3.key) === 'yes';
      })) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};